// extracted by mini-css-extract-plugin
export default {"container":"notFound_container__8N66V"};